module.exports = __webpack_public_path__ + "img/socialvalue.dca6ab7f.webp";